import { atom } from 'recoil';

const storedUser = localStorage.getItem('user');
const storedToken = localStorage.getItem('token');

export const userAtom = atom({
  key: 'userAtom',
  default: storedUser ? JSON.parse(storedUser) : null
});

export const tokenAtom = atom({
  key: 'tokenAtom',
  default: storedToken || null
});

export const isAuthenticatedAtom = atom({
  key: 'isAuthenticatedAtom',
  default: !!storedToken
});
